import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Image,
  ImageBackground,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

interface Props {
  heroImageUrl: string;
  logoUrl?: string;
  headline: string;
  byline?: string;
  ctaText: string;
  ctaUrl: string;
}

const LOGO_ASPECT_RATIO = 701 / 90;
const LOGO_MAX_HEIGHT = 54;
const LOGO_MAX_WIDTH = Math.round(LOGO_MAX_HEIGHT * LOGO_ASPECT_RATIO);
const BANNER_HORIZONTAL_SPACE = 70; // 15px banner margin * 2 + 20px logo padding * 2

const FutrHeroBanner = ({ heroImageUrl, logoUrl, headline, byline, ctaText, ctaUrl }: Props) => {
  const handleCta = () => Linking.openURL(ctaUrl);

  const [screenWidth, setScreenWidth] = useState(Dimensions.get('window').width);
  useEffect(() => {
    const sub = Dimensions.addEventListener('change', ({ window }) => setScreenWidth(window.width));
    return () => sub?.remove();
  }, []);

  const logoWidth = Math.min(LOGO_MAX_WIDTH, screenWidth - BANNER_HORIZONTAL_SPACE);
  const logoHeight = Math.round(logoWidth / LOGO_ASPECT_RATIO);

  return (
    <ImageBackground source={{ uri: heroImageUrl }} style={styles.container} resizeMode="cover">
      <View style={styles.overlay}>
        {logoUrl ? (
          <View style={styles.logoContainer}>
            <Image source={{ uri: logoUrl }} style={{ width: logoWidth, height: logoHeight }} resizeMode="stretch" />
          </View>
        ) : null}
        <View style={styles.content}>
          <Text style={styles.headline}>{headline}</Text>
          {byline ? <Text style={styles.byline}>{byline}</Text> : null}
          <TouchableOpacity style={styles.ctaButton} onPress={handleCta}>
            <Text style={styles.ctaText}>{ctaText}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    minHeight: 220,
    marginTop: 20,
    marginBottom: 10,
    marginHorizontal: 15,
  },
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(32, 27, 32, 0.55)',
    justifyContent: 'flex-start',
  },
  logoContainer: {
    padding: 20,
    paddingBottom: 0,
  },
  content: {
    marginTop: 'auto',
    padding: 20,
    paddingBottom: 24,
  },
  headline: {
    color: '#eeeeee',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  byline: {
    color: '#eeeeee',
    fontSize: 13,
    marginBottom: 16,
    opacity: 0.85,
  },
  ctaButton: {
    backgroundColor: '#e1ff00',
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  ctaText: {
    color: '#201b20',
    fontWeight: 'bold',
    fontSize: 14,
  },
});

export default FutrHeroBanner;
